import { Typography } from '@material-ui/core';
import { AdjustmentType } from 'models/Adjustment';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { getPrimaryAdjustmentType } from 'utils/adjustments';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';
import { EngineerCalendarContext } from 'views/Engineers/EngineerCalendar/EngineerCalendar';
import { adjustmentsSlice, adjustmentGroupsSlice } from 'views/Engineers/store';
import { TemporaryAdjustmentFormContext } from '../AdjustmentFormModals';

interface DeleteTemporaryAdjustmentModalProps {
  onPrevious: () => void;
}

const friendlyTypeName = (type: AdjustmentType) => {
  switch (type) {
    case AdjustmentType.Shift: {
      return 'Shift Pattern';
    }
    case AdjustmentType.Patch: {
      return 'Patch';
    }
    case AdjustmentType.Efficiency: {
      return 'Efficiency';
    }
    case AdjustmentType.Skills: {
      return 'Skills';
    }
    case AdjustmentType.MaxTravel: {
      return 'Max Travel Time';
    }
    default: {
      throw Error(`Unrecognised adjustment type '${type.toString()}'`);
    }
  }
};

export function DeleteTemporaryAdjustmentModal({
  onPrevious
}: DeleteTemporaryAdjustmentModalProps) {
  const { isOpen, setIsOpen, adjustment } = useContext(
    TemporaryAdjustmentFormContext
  );

  const dispatch = useDispatch();

  const { engineerData } = useContext(EngineerCalendarContext);

  if (!adjustment) {
    return null;
  }

  const adjustmentType = friendlyTypeName(getPrimaryAdjustmentType(adjustment));

  const handleClose = () => {
    setIsOpen?.(false);
  };

  const handleDelete = () => {
    if (engineerData) {
      if (adjustment.groupId) {
        dispatch(
          adjustmentGroupsSlice.actions.delete(adjustment, engineerData.id)
        );
        handleClose();
      } else {
        dispatch(adjustmentsSlice.actions.delete(adjustment, engineerData.id));
        handleClose();
      }
    }
  };

  return (
    <DeleteConfirmationModal
      onDelete={handleDelete}
      onCancel={onPrevious}
      onClose={handleClose}
      title={`Delete ${adjustmentType} Change`}
      open={isOpen}
      testId="deleteTemporaryAdjustmentModal"
    >
      <Typography
        data-testid="deleteTemporaryAdjustmentModalAdditionalText"
        style={{ whiteSpace: 'pre-wrap' }}
      >
        The {adjustmentType.toLowerCase()} will revert back to their default
        schedule.
      </Typography>
    </DeleteConfirmationModal>
  );
}
